import React, { Component, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

//import { useCartStore } from "../../store/cartStore";

import HamburgerMenu from 'react-hamburger-menu';

import { View, Text, Image, ActivityIndicator} from "react-native-web";



const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const HeaderPC = forwardRef((props, ref) => {

  const [open, setOpen] = useState(false);
  const openRef = useRef(false);
  //const [items, setItems] = useState(useCartStore.getState().items);

  const currentYear = new Date().getFullYear();
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;

   let _user = null;
   /*if (props.isSignedin)
   {
      _user = JSON.parse(props.sinUser);
   }*/


   const user = _user;


  const uniqueItemsCount = 0;// useCartStore((state) => state.items.length);



   //  alert(path)

    //console.log('>>> user :: ' + JSON.stringify(user));


   //  user.thumbnail = '/img/black_woman_thumb.png';
   //  user.name = 'Maicha Kabibi';


    const signOut = () => {

      localStorage.removeItem('jwtToken');
      localStorage.removeItem('yeqolaUser');

      setTimeout(() => {
         window.location = "/";
      },100);


    }


    const handleClick = () => {
         global.closeBtnClicked = true;


        let bool;
        if (global.headerBool ===  true)
        {

           bool = false;
           openRef.current = false;
           global.headerBool = false;
        }
        else
        {



           bool = true;
           openRef.current = true;
           global.headerBool = true;
        }

        //let bool = !openRef.current;
        setOpen(bool);



        props.handleMenuClick(bool);
    }


    useImperativeHandle(ref, () => ({
        closeMenu: () => {
            setOpen(false);
            global.headerBool = false;
            openRef.current = false;
        }
    }));



    const setLocale = (lang) => {



  				 localStorage.setItem("language", lang);
  				 i18n.changeLanguage(lang);


  	}



    return (

      <div className="main_header" style={{top: 0, left: 0, right: 0, width: '100%', backgroundColor: 'rgba(24, 31, 42, 0.6)'}}>


          {props.isSignedin &&
             <div className="main_header_inside">
                   <div className="main_header_inside_left" style={{width: '200px', marginTop: '5px'}}>
                      <a href="/"><img src={'https://d1asu3dhb61dau.cloudfront.net/konvv/konvv_logo_horiz_min.png'} alt="Konvv Logo" style={{height: '50px'}}/></a>
                   </div>

                   <div className="main_header_inside_right_1" style={{position: 'relative', width: '346px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>

                       {uniqueItemsCount > 0 &&
                         <div style={{position: 'absolute', zIndex: 3, right: '245px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                            {uniqueItemsCount}
                         </div>
                       }

                       <a href="/cart">
                          <View style={{cursor: 'pointer', marginTop: '5px', width: '44px', height: '44px', justifyContent: 'center'}}>
                             <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                          </View>
                        </a>


                        {1===2 &&
                          <View onClick={signOut} style={{cursor: 'pointer', marginLeft: '30px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                    borderWidth: 1, borderColor: '#fff'}}>
                             <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`Se déconnecter`}</Text>
                          </View>
                        }

                        <div style={{marginRight: '5px', marginLeft: '45px', lineHeight: '55px', color: '#fff'}}>
                           {i18n.language == 'fr' &&
                              <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                            }
                           {i18n.language == 'en' &&
                              <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                            }
                        </div>


                        <a href="/myaccount">
                           <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '3px', width: '48px', height: '48px', justifyContent: 'center'}}>
                              {user !== null && <Image source={{uri: user.thumbnail}} style={{width: '48px', height: '48px', borderRadius: '24px', border: '1px solid #999'}}/>}
                          </View>
                        </a>





                         <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '4px', width: '48px', height: '48px', justifyContent: 'center'}}>
                                    <HamburgerMenu
                                      isOpen={openRef.current}
                                      menuClicked={handleClick}
                                      width={48}
                                      height={30}
                                      strokeWidth={2}
                                      rotate={0}
                                      color='white'
                                      borderRadius={0}
                                      animationDuration={0.5}
                                     />
                          </View>


                   </div>

                     <div style={{clear: 'both'}}/>

             </div>
          }

          {!props.isSignedin &&
            <div className="main_header_inside">



                  <div style={{position: 'absolute', zIndex: 1, top: '15px', left: '10px', width: '200px'}}>
                     <a href="/"><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} alt="Re RDC Logo" style={{height: '35px'}}/></a>
                  </div>


                  <div className="menu-name-pc" style={{width: '500px', height: '100%', margin: 'auto'}}>
                       <View style={{width: '500px', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                           <View style={{height: '100%', justifyContent: 'center'}}>
                               <div><a href="/polire" style={{color: '#fff'}}>{`PoliRe`}</a></div>
                           </View>
                           <View style={{width: '30px'}}/>
                           <View style={{height: '100%', justifyContent: 'center'}}>
                               <div><a href="/armee-creative" style={{color: '#fff'}}>{`Armée créative`}</a></div>
                           </View>
                           <View style={{width: '30px'}}/>
                           <View style={{height: '100%', justifyContent: 'center'}}>
                               <div><a href="/les-femmes" style={{color: '#fff'}}>{`Les femmes`}</a></div>
                           </View>
                           <View style={{width: '30px'}}/>
                           <View style={{height: '100%', justifyContent: 'center'}}>
                               <div><a href="/principes-directeurs" style={{color: '#fff'}}>{`Principes directeurs`}</a></div>
                           </View>
                           <View style={{width: '30px'}}/>
                           <View style={{height: '100%', justifyContent: 'center'}}>
                               <div><a href="/appel-a-l-action" style={{color: '#fff'}}>{`Appel à l'action`}</a></div>
                           </View>
                       </View>
                  </div>


                 <div className="main_header_inside_right_1" style={{display: 'flex', display: 'none', marginRight: '20px',  position: 'relative',  flexDirection: 'row', justifyContent: 'flex-end'}}>

                       <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '4px', width: '48px', height: '48px', justifyContent: 'center'}}>
                            <HamburgerMenu
                              isOpen={openRef.current}
                              menuClicked={handleClick}
                              width={48}
                              height={30}
                              strokeWidth={2}
                              rotate={0}
                              color='white'
                              borderRadius={0}
                              animationDuration={0.5}
                             />
                      </View>

                </div>


                <div className="main_header_inside_right_1" style={{display: 'none', fontSize: '1.3rem', float: 'right', marginRight: '25px', lineHeight: '55px', color: '#fff'}}>
                  {i18n.language == 'fr' &&
                     <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{cursor: 'pointer', color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{cursor: 'pointer', color: '#fff'}}>FR</a></div>
                  }
                  {i18n.language == 'en' &&
                     <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{cursor: 'pointer', color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{cursor: 'pointer', color: '#fff'}}>FR</a></div>
                  }
                </div>


                 <div className="main_header_inside_right_1" style={{display: 'none', position: 'relative', width: '346px', flexDirection: 'row', justifyContent: 'flex-end'}}>

                    {uniqueItemsCount > 0 &&
                      <div style={{position: 'absolute', zIndex: 3, left: '38px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                         {uniqueItemsCount}
                      </div>
                    }

                     <a href="/cart">
                        <View style={{cursor: 'pointer', marginTop: '5px', width: '44px', height: '44px', justifyContent: 'center'}}>
                           <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                        </View>
                      </a>


                      <a href="/signin">
                         <View style={{cursor: 'pointer', marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                             borderWidth: 1, borderColor: '#fff'}}>
                            {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Mohave',}}>{`Sign in`}</Text>}
                            {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Mohave',}}>{`Se connecter`}</Text>}
                         </View>
                       </a>

                     <a href="/signup">
                       <View style={{cursor: 'pointer', marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                  borderWidth: 1, borderColor: '#fff'}}>
                           {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`Sign up`}</Text>}
                           {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`S'enregistrer`}</Text>}
                       </View>
                    </a>

                 </div>

                 <div style={{clear: 'both'}}/>


            </div>
           }



      </div>

    )

});

export default HeaderPC;
